import type { RecordUserEventsParams } from "src/service/UserEventsApi/type";
import { serverApi } from "src/service/serverApi";

export const userEventsApi = serverApi.injectEndpoints({
  endpoints: (builder) => {
    return {
      recordUserEvent: builder.mutation<
        {
          message: string;
          success: boolean;
        },
        RecordUserEventsParams
      >({
        query: (body) => {
          return {
            body,
            method: "POST",
            url: `user_events`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useRecordUserEventMutation } = userEventsApi;
